// PortalManagedRoute.js
// Blocks screens whose management moved to the admin portal for portal-access user types.
// Company / Administrator / Operation_Manager / Public_OPU users manage charging strategies,
// load-management groups and business charger groups from the portal, not from the mobile app.
// Private operators (plain OPU users) keep access to group management in mobile.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userTypeEnum } from '../../enums/auth/userType.enum';

export const PORTAL_MANAGED_USER_TYPES = [
    userTypeEnum.Administrator,
    userTypeEnum.Company,
    userTypeEnum.OperationManager,
    userTypeEnum.Public_OPU,
];

export const isPortalManagedUserType = (userType) => PORTAL_MANAGED_USER_TYPES.includes((userType || '').trim());

const PortalManagedRoute = ({ redirectTo = '/payments', children }) => {
    const { userInfo } = useSelector((state) => state.userInfoReducer);

    if (isPortalManagedUserType(userInfo?.userType)) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};

export default PortalManagedRoute;
